import expr from "expression-eval";
import { formatCondition } from "./helpers";
export const evaluateCondition = (condition, variables) => {
    const ast = expr.parse(formatCondition(condition));
    return expr.eval(ast, variables);
};
//# sourceMappingURL=conditions.js.map